/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Api
 * StudyFlow AI API specification
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  AuthResponse,
  ChatMessage,
  CreateSessionBody,
  ErrorResponse,
  GenerateStudyOutputsBody,
  HealthStatus,
  ListSessionsParams,
  LoginBody,
  PlanDefinition,
  RegisterBody,
  SendChatMessageBody,
  StudySession,
  StudySessionDetail,
  SuccessResponse,
  UpdateProfileBody,
  UpgradePlanBody,
  UpgradeResponse,
  UploadSessionFileBody,
  UsageInfo,
  User,
  UserProfile,
} from "./api.schemas";

import { customFetch } from "../custom-fetch";
import type { ErrorType, BodyType } from "../custom-fetch";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Returns server health status
 * @summary Health check
 */
export const getHealthCheckUrl = () => {
  return `/api/healthz`;
};

export const healthCheck = async (
  options?: RequestInit,
): Promise<HealthStatus> => {
  return customFetch<HealthStatus>(getHealthCheckUrl(), {
    ...options,
    method: "GET",
  });
};

export const getHealthCheckQueryKey = () => {
  return [`/api/healthz`] as const;
};

export const getHealthCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHealthCheckQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({
    signal,
  }) => healthCheck({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HealthCheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof healthCheck>>
>;
export type HealthCheckQueryError = ErrorType<unknown>;

/**
 * @summary Health check
 */

export function useHealthCheck<
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHealthCheckQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Register a new user
 */
export const getRegisterUrl = () => {
  return `/api/auth/register`;
};

export const register = async (
  registerBody: RegisterBody,
  options?: RequestInit,
): Promise<AuthResponse> => {
  return customFetch<AuthResponse>(getRegisterUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(registerBody),
  });
};

export const getRegisterMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof register>>,
    TError,
    { data: BodyType<RegisterBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof register>>,
  TError,
  { data: BodyType<RegisterBody> },
  TContext
> => {
  const mutationKey = ["register"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof register>>,
    { data: BodyType<RegisterBody> }
  > = (props) => {
    const { data } = props ?? {};

    return register(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegisterMutationResult = NonNullable<
  Awaited<ReturnType<typeof register>>
>;
export type RegisterMutationBody = BodyType<RegisterBody>;
export type RegisterMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Register a new user
 */
export const useRegister = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof register>>,
    TError,
    { data: BodyType<RegisterBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof register>>,
  TError,
  { data: BodyType<RegisterBody> },
  TContext
> => {
  return useMutation(getRegisterMutationOptions(options));
};

/**
 * @summary Log in
 */
export const getLoginUrl = () => {
  return `/api/auth/login`;
};

export const login = async (
  loginBody: LoginBody,
  options?: RequestInit,
): Promise<AuthResponse> => {
  return customFetch<AuthResponse>(getLoginUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(loginBody),
  });
};

export const getLoginMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof login>>,
    TError,
    { data: BodyType<LoginBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof login>>,
  TError,
  { data: BodyType<LoginBody> },
  TContext
> => {
  const mutationKey = ["login"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof login>>,
    { data: BodyType<LoginBody> }
  > = (props) => {
    const { data } = props ?? {};

    return login(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LoginMutationResult = NonNullable<
  Awaited<ReturnType<typeof login>>
>;
export type LoginMutationBody = BodyType<LoginBody>;
export type LoginMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Log in
 */
export const useLogin = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof login>>,
    TError,
    { data: BodyType<LoginBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof login>>,
  TError,
  { data: BodyType<LoginBody> },
  TContext
> => {
  return useMutation(getLoginMutationOptions(options));
};

/**
 * @summary Log out
 */
export const getLogoutUrl = () => {
  return `/api/auth/logout`;
};

export const logout = async (
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getLogoutUrl(), {
    ...options,
    method: "POST",
  });
};

export const getLogoutMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof logout>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof logout>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["logout"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof logout>>,
    void
  > = () => {
    return logout(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LogoutMutationResult = NonNullable<
  Awaited<ReturnType<typeof logout>>
>;

export type LogoutMutationError = ErrorType<unknown>;

/**
 * @summary Log out
 */
export const useLogout = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof logout>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof logout>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getLogoutMutationOptions(options));
};

/**
 * @summary Get current user
 */
export const getGetMeUrl = () => {
  return `/api/auth/me`;
};

export const getMe = async (options?: RequestInit): Promise<User> => {
  return customFetch<User>(getGetMeUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetMeQueryKey = () => {
  return [`/api/auth/me`] as const;
};

export const getGetMeQueryOptions = <
  TData = Awaited<ReturnType<typeof getMe>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMeQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMe>>> = ({
    signal,
  }) => getMe({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMe>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMeQueryResult = NonNullable<Awaited<ReturnType<typeof getMe>>>;
export type GetMeQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get current user
 */

export function useGetMe<
  TData = Awaited<ReturnType<typeof getMe>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMeQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List all study sessions for current user
 */
export const getListSessionsUrl = (params?: ListSessionsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/sessions?${stringifiedParams}`
    : `/api/sessions`;
};

export const listSessions = async (
  params?: ListSessionsParams,
  options?: RequestInit,
): Promise<StudySession[]> => {
  return customFetch<StudySession[]>(getListSessionsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListSessionsQueryKey = (params?: ListSessionsParams) => {
  return [`/api/sessions`, ...(params ? [params] : [])] as const;
};

export const getListSessionsQueryOptions = <
  TData = Awaited<ReturnType<typeof listSessions>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ListSessionsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listSessions>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSessionsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSessions>>> = ({
    signal,
  }) => listSessions(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listSessions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListSessionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSessions>>
>;
export type ListSessionsQueryError = ErrorType<ErrorResponse>;

/**
 * @summary List all study sessions for current user
 */

export function useListSessions<
  TData = Awaited<ReturnType<typeof listSessions>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ListSessionsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listSessions>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListSessionsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a new study session
 */
export const getCreateSessionUrl = () => {
  return `/api/sessions`;
};

export const createSession = async (
  createSessionBody: CreateSessionBody,
  options?: RequestInit,
): Promise<StudySession> => {
  return customFetch<StudySession>(getCreateSessionUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createSessionBody),
  });
};

export const getCreateSessionMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSession>>,
    TError,
    { data: BodyType<CreateSessionBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSession>>,
  TError,
  { data: BodyType<CreateSessionBody> },
  TContext
> => {
  const mutationKey = ["createSession"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSession>>,
    { data: BodyType<CreateSessionBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createSession(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateSessionMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSession>>
>;
export type CreateSessionMutationBody = BodyType<CreateSessionBody>;
export type CreateSessionMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Create a new study session
 */
export const useCreateSession = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSession>>,
    TError,
    { data: BodyType<CreateSessionBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createSession>>,
  TError,
  { data: BodyType<CreateSessionBody> },
  TContext
> => {
  return useMutation(getCreateSessionMutationOptions(options));
};

/**
 * @summary Upload a file to create a study session
 */
export const getUploadSessionFileUrl = () => {
  return `/api/sessions/upload`;
};

export const uploadSessionFile = async (
  uploadSessionFileBody: UploadSessionFileBody,
  options?: RequestInit,
): Promise<StudySession> => {
  const formData = new FormData();
  formData.append(`file`, uploadSessionFileBody.file);
  if (uploadSessionFileBody.title !== undefined) {
    formData.append(`title`, uploadSessionFileBody.title);
  }

  return customFetch<StudySession>(getUploadSessionFileUrl(), {
    ...options,
    method: "POST",
    body: formData,
  });
};

export const getUploadSessionFileMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadSessionFile>>,
    TError,
    { data: BodyType<UploadSessionFileBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uploadSessionFile>>,
  TError,
  { data: BodyType<UploadSessionFileBody> },
  TContext
> => {
  const mutationKey = ["uploadSessionFile"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uploadSessionFile>>,
    { data: BodyType<UploadSessionFileBody> }
  > = (props) => {
    const { data } = props ?? {};

    return uploadSessionFile(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UploadSessionFileMutationResult = NonNullable<
  Awaited<ReturnType<typeof uploadSessionFile>>
>;
export type UploadSessionFileMutationBody = BodyType<UploadSessionFileBody>;
export type UploadSessionFileMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Upload a file to create a study session
 */
export const useUploadSessionFile = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadSessionFile>>,
    TError,
    { data: BodyType<UploadSessionFileBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof uploadSessionFile>>,
  TError,
  { data: BodyType<UploadSessionFileBody> },
  TContext
> => {
  return useMutation(getUploadSessionFileMutationOptions(options));
};

/**
 * @summary Get a study session with all its outputs
 */
export const getGetSessionUrl = (id: number) => {
  return `/api/sessions/${id}`;
};

export const getSession = async (
  id: number,
  options?: RequestInit,
): Promise<StudySessionDetail> => {
  return customFetch<StudySessionDetail>(getGetSessionUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetSessionQueryKey = (id: number) => {
  return [`/api/sessions/${id}`] as const;
};

export const getGetSessionQueryOptions = <
  TData = Awaited<ReturnType<typeof getSession>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSession>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSessionQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSession>>> = ({
    signal,
  }) => getSession(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSession>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSessionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSession>>
>;
export type GetSessionQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get a study session with all its outputs
 */

export function useGetSession<
  TData = Awaited<ReturnType<typeof getSession>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSession>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSessionQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Delete a study session
 */
export const getDeleteSessionUrl = (id: number) => {
  return `/api/sessions/${id}`;
};

export const deleteSession = async (
  id: number,
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getDeleteSessionUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteSessionMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSession>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSession>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteSession"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSession>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteSession(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteSessionMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSession>>
>;

export type DeleteSessionMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Delete a study session
 */
export const useDeleteSession = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSession>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteSession>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteSessionMutationOptions(options));
};

/**
 * @summary Generate AI study outputs for a session
 */
export const getGenerateStudyOutputsUrl = (id: number) => {
  return `/api/sessions/${id}/generate`;
};

export const generateStudyOutputs = async (
  id: number,
  generateStudyOutputsBody?: GenerateStudyOutputsBody,
  options?: RequestInit,
): Promise<StudySessionDetail> => {
  return customFetch<StudySessionDetail>(getGenerateStudyOutputsUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(generateStudyOutputsBody),
  });
};

export const getGenerateStudyOutputsMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateStudyOutputs>>,
    TError,
    { id: number; data: BodyType<GenerateStudyOutputsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateStudyOutputs>>,
  TError,
  { id: number; data: BodyType<GenerateStudyOutputsBody> },
  TContext
> => {
  const mutationKey = ["generateStudyOutputs"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateStudyOutputs>>,
    { id: number; data: BodyType<GenerateStudyOutputsBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return generateStudyOutputs(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateStudyOutputsMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateStudyOutputs>>
>;
export type GenerateStudyOutputsMutationBody =
  BodyType<GenerateStudyOutputsBody>;
export type GenerateStudyOutputsMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Generate AI study outputs for a session
 */
export const useGenerateStudyOutputs = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateStudyOutputs>>,
    TError,
    { id: number; data: BodyType<GenerateStudyOutputsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof generateStudyOutputs>>,
  TError,
  { id: number; data: BodyType<GenerateStudyOutputsBody> },
  TContext
> => {
  return useMutation(getGenerateStudyOutputsMutationOptions(options));
};

/**
 * @summary Get chat messages for a session
 */
export const getGetChatMessagesUrl = (id: number) => {
  return `/api/sessions/${id}/chat`;
};

export const getChatMessages = async (
  id: number,
  options?: RequestInit,
): Promise<ChatMessage[]> => {
  return customFetch<ChatMessage[]>(getGetChatMessagesUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetChatMessagesQueryKey = (id: number) => {
  return [`/api/sessions/${id}/chat`] as const;
};

export const getGetChatMessagesQueryOptions = <
  TData = Awaited<ReturnType<typeof getChatMessages>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getChatMessages>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetChatMessagesQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getChatMessages>>> = ({
    signal,
  }) => getChatMessages(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getChatMessages>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetChatMessagesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getChatMessages>>
>;
export type GetChatMessagesQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get chat messages for a session
 */

export function useGetChatMessages<
  TData = Awaited<ReturnType<typeof getChatMessages>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getChatMessages>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetChatMessagesQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Send a chat message (streams response)
 */
export const getSendChatMessageUrl = (id: number) => {
  return `/api/sessions/${id}/chat`;
};

export const sendChatMessage = async (
  id: number,
  sendChatMessageBody: SendChatMessageBody,
  options?: RequestInit,
): Promise<string> => {
  return customFetch<string>(getSendChatMessageUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(sendChatMessageBody),
  });
};

export const getSendChatMessageMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendChatMessage>>,
    TError,
    { id: number; data: BodyType<SendChatMessageBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendChatMessage>>,
  TError,
  { id: number; data: BodyType<SendChatMessageBody> },
  TContext
> => {
  const mutationKey = ["sendChatMessage"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendChatMessage>>,
    { id: number; data: BodyType<SendChatMessageBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return sendChatMessage(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendChatMessageMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendChatMessage>>
>;
export type SendChatMessageMutationBody = BodyType<SendChatMessageBody>;
export type SendChatMessageMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Send a chat message (streams response)
 */
export const useSendChatMessage = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendChatMessage>>,
    TError,
    { id: number; data: BodyType<SendChatMessageBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof sendChatMessage>>,
  TError,
  { id: number; data: BodyType<SendChatMessageBody> },
  TContext
> => {
  return useMutation(getSendChatMessageMutationOptions(options));
};

/**
 * @summary Get current usage and plan info
 */
export const getGetUsageUrl = () => {
  return `/api/subscription/usage`;
};

export const getUsage = async (options?: RequestInit): Promise<UsageInfo> => {
  return customFetch<UsageInfo>(getGetUsageUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetUsageQueryKey = () => {
  return [`/api/subscription/usage`] as const;
};

export const getGetUsageQueryOptions = <
  TData = Awaited<ReturnType<typeof getUsage>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getUsage>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUsageQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUsage>>> = ({
    signal,
  }) => getUsage({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUsage>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetUsageQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUsage>>
>;
export type GetUsageQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get current usage and plan info
 */

export function useGetUsage<
  TData = Awaited<ReturnType<typeof getUsage>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getUsage>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetUsageQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get available plans
 */
export const getGetPlansUrl = () => {
  return `/api/subscription/plans`;
};

export const getPlans = async (
  options?: RequestInit,
): Promise<PlanDefinition[]> => {
  return customFetch<PlanDefinition[]>(getGetPlansUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetPlansQueryKey = () => {
  return [`/api/subscription/plans`] as const;
};

export const getGetPlansQueryOptions = <
  TData = Awaited<ReturnType<typeof getPlans>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getPlans>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPlansQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlans>>> = ({
    signal,
  }) => getPlans({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPlans>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPlansQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPlans>>
>;
export type GetPlansQueryError = ErrorType<unknown>;

/**
 * @summary Get available plans
 */

export function useGetPlans<
  TData = Awaited<ReturnType<typeof getPlans>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getPlans>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPlansQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Upgrade subscription plan
 */
export const getUpgradePlanUrl = () => {
  return `/api/subscription/upgrade`;
};

export const upgradePlan = async (
  upgradePlanBody: UpgradePlanBody,
  options?: RequestInit,
): Promise<UpgradeResponse> => {
  return customFetch<UpgradeResponse>(getUpgradePlanUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(upgradePlanBody),
  });
};

export const getUpgradePlanMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upgradePlan>>,
    TError,
    { data: BodyType<UpgradePlanBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof upgradePlan>>,
  TError,
  { data: BodyType<UpgradePlanBody> },
  TContext
> => {
  const mutationKey = ["upgradePlan"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof upgradePlan>>,
    { data: BodyType<UpgradePlanBody> }
  > = (props) => {
    const { data } = props ?? {};

    return upgradePlan(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpgradePlanMutationResult = NonNullable<
  Awaited<ReturnType<typeof upgradePlan>>
>;
export type UpgradePlanMutationBody = BodyType<UpgradePlanBody>;
export type UpgradePlanMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Upgrade subscription plan
 */
export const useUpgradePlan = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upgradePlan>>,
    TError,
    { data: BodyType<UpgradePlanBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof upgradePlan>>,
  TError,
  { data: BodyType<UpgradePlanBody> },
  TContext
> => {
  return useMutation(getUpgradePlanMutationOptions(options));
};

/**
 * @summary Get user profile
 */
export const getGetProfileUrl = () => {
  return `/api/users/profile`;
};

export const getProfile = async (
  options?: RequestInit,
): Promise<UserProfile> => {
  return customFetch<UserProfile>(getGetProfileUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetProfileQueryKey = () => {
  return [`/api/users/profile`] as const;
};

export const getGetProfileQueryOptions = <
  TData = Awaited<ReturnType<typeof getProfile>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getProfile>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProfileQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProfile>>> = ({
    signal,
  }) => getProfile({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProfile>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetProfileQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProfile>>
>;
export type GetProfileQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get user profile
 */

export function useGetProfile<
  TData = Awaited<ReturnType<typeof getProfile>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getProfile>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetProfileQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update user profile
 */
export const getUpdateProfileUrl = () => {
  return `/api/users/profile`;
};

export const updateProfile = async (
  updateProfileBody: UpdateProfileBody,
  options?: RequestInit,
): Promise<User> => {
  return customFetch<User>(getUpdateProfileUrl(), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateProfileBody),
  });
};

export const getUpdateProfileMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateProfile>>,
    TError,
    { data: BodyType<UpdateProfileBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateProfile>>,
  TError,
  { data: BodyType<UpdateProfileBody> },
  TContext
> => {
  const mutationKey = ["updateProfile"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateProfile>>,
    { data: BodyType<UpdateProfileBody> }
  > = (props) => {
    const { data } = props ?? {};

    return updateProfile(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateProfileMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateProfile>>
>;
export type UpdateProfileMutationBody = BodyType<UpdateProfileBody>;
export type UpdateProfileMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Update user profile
 */
export const useUpdateProfile = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateProfile>>,
    TError,
    { data: BodyType<UpdateProfileBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateProfile>>,
  TError,
  { data: BodyType<UpdateProfileBody> },
  TContext
> => {
  return useMutation(getUpdateProfileMutationOptions(options));
};
